"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDotMenu = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("circle", {
    cx: "35",
    cy: "35",
    r: "5.99"
  }), _react["default"].createElement("circle", {
    cx: "35",
    cy: "15.31",
    r: "5.99"
  }), _react["default"].createElement("circle", {
    cx: "35",
    cy: "54.69",
    r: "5.99"
  })),
  height: undefined,
  width: undefined
});
IconDotMenu.displayName = 'IconDotMenu';
var _default = IconDotMenu;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/dot-menu.js
// module id = 172
// module chunks = 0